import * as React from 'react'
import {
  ComposedChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Bar,
  Line,
  Tooltip,
} from 'recharts'
import { Props } from './types'
import './styles.scss'
import { NoData } from '../NoData';
import FormatText from '../../helpers/FormatText';

function CustomTooltip({ active, payload, t }: any): JSX.Element | null {
  if (active) {
    return (
      <div className="custom_tooltip">
        <div className="custom_tooltip__title custom_tooltip__title--center">
          {payload[0]?.payload.XAxisTitle}
        </div>
        <div
          className="custom_tooltip__title"
          style={{ color: payload[0]?.color }}
        >
          <span>
            {payload[0]?.name} : {FormatText.formatNumber(payload[0]?.value)}{payload[0]?.payload?.currency?.name === payload[0]?.name ? payload[0]?.payload?.currency.value : ''}
          </span>
        </div>
        <div
          className="custom_tooltip__title"
          style={{ color: payload[1]?.color }}
        >
          <span>
            {payload[1]?.name} : {FormatText.formatNumber(payload[1]?.value)}{payload[1]?.payload?.currency?.name === payload[1]?.name ? payload[1]?.payload?.currency.value : ''}
          </span>
        </div>
      </div>
    );
  }

  return null
}

export class AreaChart extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.state = {}
  }

  render() {
    const {
      XAxisTitle,
      YAxisTitle,
      YAxisTitleRight,
      barTitle,
      data,
      title,
    } = this.props

    const displayLegends = [
      {
        name: YAxisTitleRight,
        color: '#1F2534'
      },
      {
        name: barTitle,
        color: '#FF1630',
      }
    ]

    return (
      <div className="areaChart">
        <div className="areaChart__wrapper">
          <p className="areaChart__title">{title}</p>
          <div className="areaChart__legends">
            {displayLegends?.map(item => (
              <div className="areaChart__legend">
                <div className="areaChart__legend__chip" style={{ backgroundColor: item.color }} />
                <p className="areaChart__legend__title">{item.name}</p>
              </div>
            ))}
          </div>
        </div>
        {
          Array.isArray(data) && data.length > 0 ? (
            <ResponsiveContainer debounce={300} height={300}>
              <ComposedChart
                width={730}
                data={data}
              >
                <XAxis
                  dataKey={XAxisTitle}
                  tickFormatter={value => value.length > 0 ? value : ''}
                />
                <YAxis
                  yAxisId="0"
                  dataKey={YAxisTitle}
                  tickFormatter={value => value}
                />
                <YAxis
                  orientation="right"
                  yAxisId="1"
                  dataKey={YAxisTitleRight}
                  tickFormatter={value => value}
                />
                <CartesianGrid vertical horizontal={false} stroke="#D8D8D8" />
                <Tooltip active={true} content={<CustomTooltip />} />
                <Bar dataKey={barTitle} yAxisId="0" barSize={10} fill="#FF1630" />
                <Line
                  type="monotone"
                  yAxisId="1"
                  dataKey={YAxisTitleRight}
                  stroke="#1F2534"
                  strokeWidth={3}
                />
              </ComposedChart>
            </ResponsiveContainer>
          ) : (
              <NoData />
            )
        }
      </div>
    )
  }
}
